/** @format */

import { TLocale } from '@/utils/gatsby/types';
import moment from 'moment';
import { TListType } from '../../general/declarations';
import { TRoom } from '../../room/declarations';

const event = 'GAevent';
const brand = 'coliving';

declare global {
  interface Window {
    dataLayer: any;
  }
}

export const utilityGTMBlogSetup = ({
  country = '',
  city = '',
  neighborhood = '',
  language,
  pageType,
  brand,
}: {
  country?: string;
  city?: string;
  neighborhood?: string;
  language: string;
  pageType: string;
  brand?: string;
}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'wSetup',
    country,
    city,
    neighborhood,
    language,
    currencyCode: 'EUR',
    pageType,
    marketingCookie: 1,
    brand,
  });
};

export const utilityGtmBlogCategory = (category: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'search_article',
    position: 'blog',
    label: category,
  });
};

export const utilityGtmBlogSearch = (input: string, articleName: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    position: 'blog',
    event_name: 'search_article',
    label: input,
    type: articleName,
  });
};

export const utilityGtmBlogSocial = (social: string, name: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'share_article',
    position: 'blog',
    label: name,
    type: social,
  });
};

export const utilityGtmBlog = (category: string, name: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'blog',
    position: 'blog',
    label: name,
    type: category,
  });
};

export const utilityGtmWywgCarousel = (section: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'wywg_carousel',
    position: 'what_you_will_get',
    label: section.replace(/\s+/g, '_').toLowerCase(),
    brand,
  });
};

export const utilityGtmWywgService = (info: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'our_services',
    position: 'what_you_will_get',
    label: info.replace(/\s+/g, '_').toLowerCase(),
    brand,
  });
};

export const utilityGtmWywgPatners = (info: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'our_partner',
    position: 'what_you_will_get',
    label: info.replace(/\s+/g, '_').toLowerCase(),
    brand,
  });
};

export const utilityGtmMoreOption = (choice: 'filter' | 'listing_room', selection: string, moreInfo: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'more_options_pdp',
    label: selection,
    product: moreInfo,
    position: 'room_detail',
    type: `more_options_${choice}`,
    brand: 'dovevivo',
  });
};

export const GTMVisitOtherRoomsv2 = (roomId: string, roomRef: string, monthlyRate: number) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'pdp_visit_other_room',
    position: 'room_detail',
    product: roomRef,
    label: monthlyRate,
    type: roomId,
    brand: 'dovevivo',
  });
};

export const GTMFilterHomepage = (city: string, filter: string, country: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_category: 'filter_homepage',
    event_name: 'homepage_filter',
    label: city,
    position: country,
    type: filter,
    brand,
  });
};

export const GTMsetup = ({
  city = '',
  neighborhood = '',
  country = '',
  brand = '',
  language,
  pageType = '',
}: {
  city?: string;
  neighborhood?: string;
  country?: string;
  brand?: string;
  language: TLocale;
  pageType: string;
}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'wSetup',
    country,
    city,
    neighborhood,
    language,
    currencyCode: 'EUR',
    pageType,
    marketingCookie: 1,
    brand,
  });
};

export const GTMheader = (label: string, option?: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'header',
    label,
    type: option ?? label,
    brand,
  });
};

export const GTMsocial = (social: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_category: 'social',
    event_name: 'social',
    label: social,
    brand,
  });
};

export const GTMfooter = (item: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_category: 'footer',
    event_name: 'footer',
    position: item,
    brand,
  });
};

export const GTMwywg = (title: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'hp_interaction',
    position: 'what_you_will_get',
    label: title,
    brand,
  });
};

export const GTMHowItWorks = (title: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'hp_interaction',
    position: 'how_it_works',
    label: title,
    brand,
  });
};

export const GTMmenu = (position: string, label: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'hp_interaction',
    event_category: 'menu',
    position,
    label,
    brand,
  });
};

export const GTMbookVisit = (monthlyRate: number, roomCode: string, visitType: string, formID?: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: `book_visit_s1`,
    label: monthlyRate,
    position: 'room_detail',
    product: roomCode,
    type: `step1_${visitType}`,
    brand,
    step: `step1`,
    period: moment().format('YYYYMMDD_HHmmss'),
    formID,
  });
};

export const GTMbookVisitBack = (monthlyRate: number, roomCode: string, visitType: string, formID?: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: `book_visit_back`,
    label: monthlyRate,
    position: 'room_detail',
    product: roomCode,
    type: `back_${visitType}`,
    brand,
    step: `back`,
    period: moment().format('YYYYMMDD_HHmmss'),
    formID,
  });
};

export const GTMbookVisitContinue = (monthlyRate: number, roomCode: string, visitType: string, formID?: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: `book_visit_s2`,
    label: monthlyRate,
    position: 'room_detail',
    product: roomCode,
    type: `step2_${visitType}`,
    brand,
    step: `step2`,
    period: moment().format('YYYYMMDD_HHmmss'),
    formID,
  });
};

export const GTMbookVisitEnd = (
  monthlyRate: number,
  roomCode: string,
  visitType: string,
  status: 'success' | 'fail',
  formID?: string,
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: `book_visit_ok`,
    label: monthlyRate,
    position: 'room_detail',
    product: roomCode,
    type: `book_visit_ok_${visitType}`,
    brand,
    step: `ok`,
    period: moment().format('YYYYMMDD_HHmmss'),
    status,
    formID,
  });
};

export const GTMBookARoom = (roomCode: string, monthlyRate: number, formId: string) => {
  const timestamp = moment().format('YYYYMMDD_HHmmss');
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'book_a_room',
    label: monthlyRate,
    position: 'room_detail',
    product: roomCode,
    brand,
    step: 'step1',
    timestamp,
    formID: formId,
  });
};

export const GTMAddToCart = (
  roomCode: string,
  monthlyRate: number,
  roomName: string,
  cityNeighborood: string,
  roomType: string,
  discountOrFull: string,
  availability: string,
  position: string,
  order: string,
  filter: string,
  listType: string,
) => {
  const timestamp = moment().format('YYYYMMDD_HHmmss');
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'add_to_cart',
    brand,
    ecommerce: {
      currency: 'EUR',
      order,
      filter,
      items: [
        {
          item_name: roomName,
          item_id: roomCode,
          price: monthlyRate,
          item_brand: cityNeighborood,
          item_category: roomType,
          item_list_name: listType,
          rate_type: discountOrFull,
          position,
          availability,
        },
      ],
    },
  });
};

export const GTMBookingContacts = (roomCode: string, monthlyRate: number, formId: string) => {
  const timestamp = moment().format('YYYYMMDD_HHmmss');
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'book_a_room',
    label: monthlyRate,
    position: 'checkout',
    product: roomCode,
    brand,
    step: 'step2',
    formID: formId,
    timestamp,
  });
};

export const GTMBookingToPayment = (roomCode: string, monthlyRate: number, howDidYouFindUs: string, formID: string) => {
  const timestamp = moment().format('YYYYMMDD_HHmmss');
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'book_a_room',
    label: monthlyRate,
    position: 'checkout',
    product: roomCode,
    brand,
    step: 'step3',
    type: howDidYouFindUs,
    timestamp,
    formID,
  });
};

export const GTMBookingConfirm = (roomCode: string, monthlyRate: number, formID: string) => {
  const timestamp = moment().format('YYYYMMDD_HHmmss');
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'book_a_room',
    label: monthlyRate,
    position: 'checkout',
    product: roomCode,
    brand,
    step: 'step4',
    timestamp,
    formID,
  });
};

export const GTMBookingEditDates = (roomCode: string, monthlyRate: number, dates: string[], formID: string) => {
  const startDate = new Date(dates[0]);
  const endDate = new Date(dates[1]);
  const monthsDiff = Math.round((endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 / 24 / 30);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'edit_dates',
    label: monthlyRate,
    position: 'checkout',
    product: roomCode,
    brand,
    period: `${monthsDiff}_months`,
    date: `${moment(startDate).format('YYYYMMDD_HHmmss')} - ${moment(endDate).format('YYYYMMDD_HHmmss')}`,
    formID,
  });
};

export const GTMBookingFinancialOption = (roomCode: string, type: string, formID: string) => {
  const timestamp = moment().format('YYYYMMDD_HHmmss');
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'financial_validation',
    position: 'checkout',
    product: roomCode,
    brand,
    formID,
    type,
    timestamp,
  });
};

export const GTMBookingTaxCodeModal = (roomCode: string, type: string, formID: string) => {
  const timestamp = moment().format('YYYYMMDD_HHmmss');
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'tax_code',
    position: 'checkout',
    product: roomCode,
    brand,
    formID,
    type,
    timestamp,
  });
};

export const GTMBookingDownloadApp = (roomCode: string, type: string, formID: string) => {
  const timestamp = moment().format('YYYYMMDD_HHmmss');
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'download_app',
    position: 'typ',
    product: roomCode,
    brand,
    type,
    timestamp,
    formID,
  });
};

export const GTMBookingError = (roomCode: string, monthlyRate: number | string, step: string, formID: string) => {
  const timestamp = moment().format('YYYYMMDD_HHmmss');
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'book_room_error',
    position: 'checkout',
    label: monthlyRate,
    product: roomCode,
    brand,
    step,
    timestamp,
    formID,
  });
};

export const GTMWhatsAppCta = (roomCode: TRoom['code'], monthlyRate: number) => {
  const timestamp = moment().format('YYYYMMDD_HHmmss');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'whatsapp_cta',
    label: monthlyRate,
    position: 'room_detail',
    product: roomCode,
    brand: 'dovevivo',
    period: timestamp,
  });
};

export const GTMproductDetail = ({ order, filter, item }: { order: string; filter: string; item: TGTMBookingItem }) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'view_item',
    brand,
    ecommerce: {
      currency: 'EUR',
      order,
      filter,
      items: [item],
    },
  });
};

export const GTMvirtualTour = ({
  city,
  moreInfo,
  monthlyRate,
}: {
  city: string;
  moreInfo: string;
  monthlyRate: number;
}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'virtual_tour',
    type: city,
    product: moreInfo,
    label: monthlyRate,
    brand,
  });
};

export const GTMCityAndNeighborhoodSectionFilter = (
  city: string,
  filterSelected: string,
  currentPage: 'city_page' | 'neighborhoods_page',
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: `${currentPage}_filter`,
    label: filterSelected,
    type: city,
  });
};

export const GTMCityAndNeighborhoodsApartmentCarousel = (
  city: string,
  roomRef: string,
  selectedFilter: string,
  currentPage: 'city_page' | 'neighborhoods_page',
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'apartment_carousel',
    label: selectedFilter,
    position: currentPage,
    product: roomRef,
    type: city,
    brand,
  });
};

export const GTMCityAndNeighborhoodApartmentCta = (city: string, currentPage: 'city' | 'neighborhoods') => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: `${currentPage}_cta`,
    label: 'apartment_carousel',
    position: currentPage,
    type: city,
    brand,
  });
};

export const GTMCityAndNeighborhoodFaq = (
  city: string,
  selection: string,
  currentPage: 'city_page' | 'neighborhoods_page',
  currentPageFaq: 'citypage_faq' | 'neighborhoodpage_faq',
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: currentPageFaq,
    category: currentPage,
    label: selection,
    type: city,
    brand,
  });
};

export const GTMCityOtherCityCarousel = (city: string, selectionClick: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'other_city_carousel',
    category: 'city_page',
    label: `${selectionClick}_click`,
    type: city,
    brand,
  });
};

export const GTMOtherNeighborhoodsCarousel = (
  city: string,
  selectionClick: string,
  currentPage: 'city_page' | 'neighborhood_page',
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'neighborhood_carousel',
    category: currentPage,
    label: `${selectionClick}_click`,
    product: city,
    brand,
  });
};

export const GTMPDPMapInteractionZoom = (zoomAction: 'zoom_in' | 'zoom_out', roomRef: string, monthlyRate: number) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'pdp_map_zoom',
    type: zoomAction,
    product: roomRef,
    label: monthlyRate,
    position: 'room_detail',
    brand: 'dovevivo',
  });
};

export const GTMPDPMapInteractionAddressClick = (roomRef: string, monthlyRate: number) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'pdp_open_maps',
    product: roomRef,
    label: monthlyRate,
    position: 'room_detail',
    brand: 'dovevivo',
  });
};

export const GTMPDPNeighborhoodClick = (roomRef: string, monthlyRate: number, neighborhood: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'pdp_open_neighborhood',
    type: neighborhood,
    product: roomRef,
    label: monthlyRate,
    position: 'room_detail',
    brand: 'dovevivo',
  });
};

export const GTMPDPRoomGalleryImageAndAllClick = (roomRef: string, monthlyRate: number) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'pdp_open_gallery',
    position: 'room_detail',
    label: monthlyRate,
    product: roomRef,
    brand: 'dovevivo',
  });
};

export const GTMPDPRoomGalleryImageClick = (roomRef: string, monthlyRate: number, imagePosition: number) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'pdp_select_image',
    position: 'room_detail',
    type: imagePosition,
    product: roomRef,
    label: monthlyRate, //TODO: update the key
    brand: 'dovevivo',
  });
};

export const GTMPDPRoomGalleryCarouselClick = (roomRef: string, monthlyRate: number, imagePosition: number) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'pdp_slide_gallery',
    position: 'room_detail',
    type: imagePosition,
    product: roomRef,
    label: monthlyRate,
    brand: 'dovevivo',
  });
};

export const GTMPDPShowAllServices = (roomRef: string, monthlyRate: number) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'pdp_show_services',
    position: 'room_detail',
    product: roomRef,
    label: monthlyRate,
    brand: 'dovevivo',
  });
};

export const GTMUtilityBoxCta = (position: string, label: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'hp_interaction',
    event_category: 'homepage',
    label,
    position,
    brand,
  });
};

type GTMListingFilterType =
  | 'property_type'
  | 'check_in_date'
  | 'price_range'
  | 'points_of_interest'
  | 'districts'
  | 'all_filters';

type GTMListingFilterDetailType =
  | Exclude<GTMListingFilterType, 'all_filters'>
  | 'facilities'
  | 'amenities'
  | 'suitability';

export const GTMListingFilter = (label: GTMListingFilterType) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'GAevent',
    eventName: 'filter',
    label: label,
    brand,
  });
};

export const GTMListingFilterDetail = (type: GTMListingFilterDetailType, label: string) => {
  if (['', '|'].includes(label)) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'GAevent',
    eventName: 'filter_detail',
    type: type,
    label: label,
    brand,
  });
};

export const GTMListingSortBy = (label: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'GAevent',
    eventName: 'sort_by',
    label: label,
    brand,
  });
};

export const GTMListingMapMarkerClick = ({
  pinType,
  roomCode,
  price,
}: {
  pinType: 'pin_price' | 'pin_building';
  roomCode: string;
  price: number;
}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'GAevent',
    eventName: 'interacting_with_map',
    label: price,
    product: roomCode,
    type: pinType,
  });
};

export const GTMListingCard = (
  roomCode: string,
  eventName: 'image_gallery_plp' | 'map' | 'virtual_tour' | 'planimetry',
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'GAevent',
    eventName: eventName,
    product: roomCode,
    label: 'click',
    brand,
  });
};

export const GTMListingDiscoverCta = (city: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'GAevent',
    eventName: 'box_cta',
    type: city,
    label: 'discover_city',
    brand,
  });
};

export const GTMListingShowMoreSpeaces = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'GAevent',
    eventCaption: 'cta_show_more_spaces',
    tag: 'click',
    brand,
  });
};

export const GTMListingViewItemList = (
  items: Array<{
    item_name: string;
    item_id: string;
    price: number;
    item_brand: string;
    item_category: string;
    item_list_name: TListType;
    position: number;
    rate_type: 'full_price' | 'special_offer';
    availability: string;
  }>,
  order: string,
  filter: string,
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'view_item_list',
    brand,
    ecommerce: {
      currency: 'EUR',
      order: order,
      filter: filter,
      items,
    },
  });
};

export const GTMVirtualPageView = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'virtual_pageview',
  });
};

export const GTMListingSelectItem = (
  item: {
    item_name: string;
    item_id: string;
    price: number;
    item_brand: string;
    item_category: string;
    item_list_name: TListType;
    position: number;
    rate_type: 'full_price' | 'special_offer';
    availability: string;
  },
  order: string,
  filter: string,
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'select_item',
    brand,
    ecommerce: {
      currency: 'EUR',
      order: order,
      filter: filter,
      items: [item],
    },
  });
};

export type TGTMBookingItem = {
  item_name?: string;
  item_id?: string;
  price?: number | null;
  item_brand?: string;
  item_category?: string;
  item_list_name?: TListType;
  position?: string;
  rate_type?: 'full_price' | 'special_offer';
  availability?: 'not_available' | 'available_on_next_weeks' | 'available';
  period?: string;
  fee?: number;
  deposit?: number;
  first_month_price?: number;
  promo_period?: string;
  discount?: number;
  formID?: string;
};

export const GTMBookingBeginCheckout = ({
  order,
  filter,
  item,
  date,
}: {
  order: string;
  filter: string;
  item: TGTMBookingItem;
  date: string;
}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: null,
  });

  window.dataLayer.push({
    event: 'begin_checkout',
    brand,
    ecommerce: {
      date,
      currency: 'EUR',
      order: order,
      filter: filter,
      items: [{ ...item, quantity: 1 }],
    },
  });
};

export const GTMBookingAddShippingInfo = ({
  order,
  filter,
  date,
  item,
}: {
  order: string;
  filter: string;
  date: string;
  item: TGTMBookingItem;
}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: null,
  });

  window.dataLayer.push({
    event: 'add_shipping_info',
    brand,
    ecommerce: {
      currency: 'EUR',
      order: order,
      filter: filter,
      date,
      items: [{ ...item, quantity: 1 }],
    },
  });
};

export const GTMBookingAddPaymentInfo = ({
  order,
  filter,
  paymentType,
  date,
  item,
}: {
  order: string;
  filter: string;
  paymentType: 'stripe' | 'payline';
  date: string;
  item: TGTMBookingItem;
}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: null,
  });

  window.dataLayer.push({
    event: 'add_payment_info',
    brand,
    ecommerce: {
      currency: 'EUR',
      order: order,
      filter: filter,
      payment_type: paymentType,
      date,
      items: [{ ...item, quantity: 1 }],
    },
  });
};

export const GTMAskInfoS1 = ({ monthlyRate, roomCode }: { monthlyRate: number; roomCode: string }) => {
  const timestamp = moment().format('YYYYMMDD_HHmmss');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'ask_information_s1',
    label: monthlyRate,
    position: 'room_detail',
    product: roomCode,
    brand,
    step: 'step1',
    period: timestamp,
  });
};

export const GTMAskInfoOk = ({ price, roomCode }: { price: string; roomCode: string }) => {
  const timestamp = moment().format('YYYYMMDD_HHmmss');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'ask_information_ok',
    label: Number(price), // monthlyRate
    position: 'room_detail',
    product: roomCode,
    brand,
    step: 'step3',
    period: timestamp,
    type: `ask_information_ok_write_us`,
  });
};

export const GTMPhonecallCTA = ({ monthlyRate, roomCode }: { monthlyRate: number; roomCode: string }) => {
  const timestamp = moment().format('YYYYMMDD_HHmmss');
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: 'phonecall_cta',
    label: monthlyRate,
    position: 'room_detail',
    product: roomCode,
    brand,
    period: timestamp,
  });
};

export const GTMFRClickNotify = (position: 'emptyCard' | 'cardRoom') => {
  const timestamp = moment().format('YYYYMMDD_HHmmss');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_name: position === 'emptyCard' ? 'cta_fr_click_notify_noresults' : 'cta_fr_click_notify_card',
    brand,
    period: timestamp,
  });
};

export const GTMMapInteraction = (price: number, roomCode: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'GAevent',
    event_name: 'interacting_with_map',
    type: 'pin_carousel',
    label: price,
    product: roomCode,
  });
};
